import PropTypes from 'prop-types';
import { HUBSPOT_PAGES, SUBSCRIPTION } from '@App/routes';
import I18n from 'i18n-js';
import HubspotLink from '@App/components/navigation/HubspotLink';
import Anchor from '@App/components/navigation/Anchor';
import { connect } from 'react-redux';

SubscriptionInfo.propTypes = {
    active: PropTypes.bool.isRequired,
    profile: PropTypes.shape({
        organization: PropTypes.shape({
            name: PropTypes.string.isRequired,
        }),
        isCoveredByOrganizationSubscription: PropTypes.bool,
        subscription: PropTypes.shape({
            name: PropTypes.string.isRequired,
            status: PropTypes.string.isRequired,
            startsAt: PropTypes.string.isRequired,
            finishesAt: PropTypes.string,
            nextOccurrenceAt: PropTypes.string,
            manageUrl: PropTypes.string,
        }),
    }).isRequired,
};

function SubscriptionInfo({ active, profile }) {
    const subscription = profile.subscription;

    if (!subscription) {
        // A member of a company covered by its subscription holds none of their own: they have
        // nothing to choose and nothing to manage, so offering them a plan would be plainly wrong.
        if (profile.isCoveredByOrganizationSubscription && profile.organization) {
            return <SubscriptionSection active={active}>
                <p>
                    Votre abonnement est géré par votre organisation{' '}
                    <span style={{ textTransform: 'uppercase' }}>{profile.organization.name}</span>, pour
                    plus d’informations nous sommes joignables au{' '}
                    {/* Non-breaking spaces: a phone number split across two lines is unreadable. */}
                    <a href="tel:+33144090984">+33&nbsp;1&nbsp;44&nbsp;09&nbsp;09&nbsp;84</a> ou{' '}
                    <a href="mailto:bonjour@miooz.com">bonjour@miooz.com</a>.
                </p>
            </SubscriptionSection>;
        }

        return <SubscriptionSection active={active}>
            <div className="row">
                <div className="col-lg-3 offset-lg-4">
                    <a href={SUBSCRIPTION.getUrl()} className="btn btn--primary btn--full">Choisir mon abonnement</a>
                </div>
            </div>
        </SubscriptionSection>;
    }

    return <SubscriptionSection active={active}>
        {/* No heading above the name: the offer names itself now that it is read from the provider
            ("Plan Créateur"), and "Abonnement" over it said nothing the section title had not. */}
        <p>{ subscription.name }</p>
        <p>{ subscription.status }
            {subscription.finishesAt && <> (Fin le { I18n.l('date.formats.short', subscription.finishesAt) })</>}
            {!subscription.finishesAt && subscription.nextOccurrenceAt && <> (Renouvellement le { I18n.l('date.formats.short', subscription.nextOccurrenceAt) })</>}
        </p>
        {/* The hosted portal carries the invoices and the cancellation flow alike, so a single CTA hands the customer over to it. */}
        <p>{ subscription.manageUrl && <a href={subscription.manageUrl} target="_blank" rel="noopener noreferrer" className="btn btn--primary btn--small">Gérer mon abonnement</a> }</p>
        <p>Une question sur votre abonnement ? <HubspotLink route={HUBSPOT_PAGES.CONTACT}>Contactez-nous !</HubspotLink></p>
    </SubscriptionSection>;
}

SubscriptionSection.propTypes = {
    active: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

/**
 * The section's shell, shared by the three cases so that #abonnement scrolls to it in all of them —
 * `redirectToProfileSubscription()` links to that anchor whatever the customer holds.
 */
function SubscriptionSection({ active, children }) {
    return <Anchor active={active} id="abonnement">
        <h2 className="h1">{I18n.t('page.my_account.subscription.title')}</h2>
        <hr/>

        {children}
    </Anchor>;
}

export default connect(
    state => ({
        active: state.navigation.anchor === 'abonnement'
    })
)(SubscriptionInfo);
